import HelpTooltip from '@/app/common/components/HelpTooltip';
import { GOOGLE_QUOTA_RESET_LABEL } from '../lib/job-range';
import { guideTooltipHtml } from './CoverageHelpTip';

const INDEX_QUOTA_GUIDE = {
  matchKey: 'index-quota-today',
  title: 'مصرف امروز درخواست ایندکس',
  paragraphs: [
    `این عدد سهمیهٔ باقی‌مانده نیست؛ تعداد آدرس‌هایی است که از ریست سهمیهٔ روزانهٔ گوگل تا الان ارسال شده‌اند. ریست حدود ساعت ${GOOGLE_QUOTA_RESET_LABEL} است.`,
    'سقف روزانه ۲۰۰ آدرس است. اگر کارت صفر باشد یعنی از ریست امروز هنوز چیزی ارسال نشده و ۲۰۰ آدرس باقی مانده است. باقی‌مانده = ۲۰۰ منهای همین عدد.',
    'این کارت به بازهٔ ۷ روز یا ۱۴ روز بالای صفحه وابسته نیست. ارسال‌های دیروز فقط در کارت‌های کناری همان بازه دیده می‌شوند.',
  ],
};

export function IndexQuotaHelpTip() {
  return (
    <HelpTooltip
      html={guideTooltipHtml(INDEX_QUOTA_GUIDE)}
      placement="top"
      className="ms-1"
    />
  );
}
